import { useNavigate } from "react-router-dom";
import { CloseGreyIcon } from "../../../assets/icons";
import { useNotification } from "../../toster-notification/NotificationContext";
import { useState } from "react";
import { cityService } from "../../../services/cityService";
import { nameToSlug } from "../../../utils/slugService";
import Loader from "../../shared/Loader";

interface AddCityViewProps {
    onClose: () => void;
}

export default function AddCityView({ onClose }: AddCityViewProps) {

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [slug, setSlug] = useState("");
    const [slugError, setSlugError] = useState("");

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();

    const handleAddCity = async () => {

        setNameError("");
        setSlugError("");

        let isValid = true;

        if (!name.trim()) {
            setNameError("Name is required");
            isValid = false;
        }

        if (!slug.trim()) {
            setSlugError("Slug is required");
            isValid = false;
        }

        if (!isValid) {
            return;
        }

        setLoading(true);
        try {
            const response = await cityService.Create({ name, slug });

            if (response.success) {
                notify("success", "City Created", response.message);
                onClose();
            } else {
                notify("error", "Error Creating City", response.message);
            }
        } catch (error) {
            notify("error", "Error Creating City", "An error occurred while creating the city.");
        } finally {
            setLoading(false);
        }
    }

    if (loading) {
        return <Loader />;
    }

    return (
        <section className="modal-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="modal-wrapper">
                    <div className="modal-div">
                        <div className="modal-header-div">
                            <div>
                                <div className="modal-header">Dodaj Novi Grad</div>
                                <div className="description-text">Unesite podatke o gradu</div>
                            </div>
                            <div className="modal-button-div">
                                <img loading="lazy" src={CloseGreyIcon} alt="" className="icon-size-20 close" onClick={onClose} />
                            </div>
                        </div>
                        <div className="modal-form-block w-form">
                            <form method="get" className="modal-form" >
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Naziv Grada *</label>
                                    <input className="form-input grey w-input" placeholder="Novi Sad" type="text"
                                        value={name}
                                        onChange={(e) => {
                                            setName(e.target.value);
                                            if (e.target.value.trim()) {
                                                setNameError("");
                                            }
                                            setSlug(nameToSlug(e.target.value));
                                        }}
                                    />
                                    <div className="error-text">{nameError}</div>
                                </div>
                                <div className="modal-form-div">
                                    <label className="modal-form-label">Slug</label>
                                    <input className="form-input grey w-input" placeholder="novi-sad" type="text"
                                        value={slug}
                                        onChange={(e) => {
                                            setSlug(e.target.value);
                                            if (e.target.value.trim()) {
                                                setSlugError("");
                                            }
                                        }}
                                    />
                                    <div className="error-text">{slugError}</div>
                                </div>
                            </form>
                        </div>
                        <div className="modal-buttons">
                            <div className="button-secondary medium" onClick={onClose}>
                                <div>Otkaži</div>
                            </div>
                            <div className="button-primary medium" onClick={handleAddCity}>
                                <div>Kreiraj Grad</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}